export class Driver {
	id: string;
	first_name: string;
	last_name: string;
	status: string;
	envoiID: string;
	birthdate: string;
	phone_private: string;
	phone_business: string;
	email_private: string;
	email_business: string;
	nearest_city: string;
	name: string;
	rate: number;
	chronically_ill: number;
	comments: string;
	vaccinations: number;
	whenContact: string;
	salary: string;
	workTax: number;
	breakTax: number;
	otherTax: number;
	driverKinds: string;
	companyId: string;
	diet_cash: number;
	different_account_diet: number;
	bankaccount: string;
	documents: Documents;
}

export class Documents {
	trailer: Document;
	driverLicense: Document;
	qualification: Document;
	driverCard: Document;
	passport: Document;
	idCard: Document;
	medicalCheckUp: Document;
	psychologyCheckUp: Document;
	foreigner: Document;
	workPermit: Document;
	eta: Document;
}

export class Document {
	id: string;
	date: string;
	kind: boolean;
	checkDocument: string;
}

export interface DriverSalaryItem {
	type: RateKind;
	salary: string;
	driver: string;
	day: string;
}

export interface RateItem {
	workRate: string;
	breakRate: string;
	otherRate: string;
}

export interface CommonTable {
	id: string;
	name: string;
}

export interface DietRequiredInfo {
	dateRange: boolean;
}

export interface DriverDiet {
	id: string;
	driver: string;
	dateFrom: string;
	dateTo: string;
	kind: DriverDietKind;
	createdBy: string;
}

export interface DriverSalarySummary {
	benefits: number;
	bonusNegative: Settlement[];
	bonusPositive: Settlement[];
	cash: number;
	cashEuro: number;
	confirmedDays: boolean;
	deductions: number;
	diets: number;
	mobility: number;
	payments: number;
	paymentsEuro: number;
	rates: number;
	sumMonth: number;
	transfer: number;
	sumMonthEuro: number;
}

export interface Settlement {
	diet: number;
	value: number;
	name: string;
	month: string;
	comment: string;
}

export enum RateKind {
	WORK_RATE = '1',
	BREAK_RATE = '2',
	OTHER_RATE = '3',
}

export enum DriverDietKind {
	TRANSFER = '0',
	CASH = '1',
}

export enum SalaryBankExportKind {
	DIET = 'diet',
	MOBILITY_PACKAGE = 'mobilityPackage',
}

export const driverDietKindMapping: { [key in DriverDietKind]: string } = {
	[DriverDietKind.TRANSFER]: 'Przelew',
	[DriverDietKind.CASH]: 'Gotówka',
};
